'use client'

import { NotFound } from '@components/not-found'
import { routes } from '@constants/routes'

export default function FullProvidersNotFound() {
  return <NotFound href={routes.Home()} hrefMessage="Return to home page" />
}
